/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

/* TypeScript */
export type ProductGranularity = 'parent' | 'variant' | 'backbox'

/* Schemas */
export const ProductGranularitySchema = z.enum(['parent', 'variant', 'backbox'])

/* Schemas validation */
type TestProductGranularityApiProps = ExpectTrue<
  Equal<ProductGranularity, z.infer<typeof ProductGranularitySchema>>
>
